import { MagicConfigMixin } from '@gig/magic-common';
import { __extends, __decorate } from 'tslib';
import { Component, Mixins } from 'vue-property-decorator';
import { USER_LOGGED_IN_UPDATED, USER_LOGIN_TIME_EVENT, PANIC_BAR_VISIBLE } from '@gig/magic-messages';

/**
 * Bar for SGA. Contains session timer and links to setting limits,
 * self excluding and gaming addiction self test
 */
var SgaBarComponent = /** @class */ (function (_super) {
    __extends(SgaBarComponent, _super);
    function SgaBarComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.userLoginTime = 0;
        _this.isLoggedIn = false;
        _this.userLoginTimeSubscription = null;
        _this.loggedInSubscription = null;
        return _this;
    }
    SgaBarComponent.prototype.created = function () {
        var _this = this;
        this.loggedInSubscription = window.eventBus.subscribe(USER_LOGGED_IN_UPDATED, function (e) {
            var _a;
            _this.isLoggedIn = (_a = e.payload) !== null && _a !== void 0 ? _a : false;
        }, { replay: true });
        this.userLoginTimeSubscription = window.eventBus.subscribe(USER_LOGIN_TIME_EVENT, function (event) {
            if (event.payload) {
                _this.userLoginTime = event.payload;
            }
        }, { replay: true });
        window.eventBus.publish(PANIC_BAR_VISIBLE, true);
    };
    SgaBarComponent.prototype.destroyed = function () {
        var _a, _b;
        (_a = this.loggedInSubscription) === null || _a === void 0 ? void 0 : _a.unsubscribe();
        (_b = this.userLoginTimeSubscription) === null || _b === void 0 ? void 0 : _b.unsubscribe();
        window.eventBus.publish(PANIC_BAR_VISIBLE, false);
    };
    SgaBarComponent = __decorate([
        Component({
            name: 'sga-bar',
        })
    ], SgaBarComponent);
    return SgaBarComponent;
}(Mixins(MagicConfigMixin)));

export default SgaBarComponent;
